import { render, staticRenderFns } from "./menu_modal.vue?vue&type=template&id=03501124&scoped=true&"
import script from "./menu_modal.vue?vue&type=script&lang=js&"
export * from "./menu_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03501124",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03501124')) {
      api.createRecord('03501124', component.options)
    } else {
      api.reload('03501124', component.options)
    }
    module.hot.accept("./menu_modal.vue?vue&type=template&id=03501124&scoped=true&", function () {
      api.rerender('03501124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/sys/menu/menu_modal.vue"
export default component.exports